import { render, staticRenderFns } from "./Scripts.vue?vue&type=template&id=5db46014&"
import script from "./Scripts.vue?vue&type=script&lang=js&"
export * from "./Scripts.vue?vue&type=script&lang=js&"
import style0 from "./Scripts.vue?vue&type=style&index=0&css-scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VFlex,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db46014')) {
      api.createRecord('5db46014', component.options)
    } else {
      api.reload('5db46014', component.options)
    }
    module.hot.accept("./Scripts.vue?vue&type=template&id=5db46014&", function () {
      api.rerender('5db46014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Scripts.vue"
export default component.exports